import { Injectable } from '@angular/core';
import { ApiBaseService } from '@core/services/base/api-base.service';
import { environment } from '@environments/environment';
import { FeaturedBrandInterface } from '../interfaces/featured-brand.interface';
import { FeaturedBrandModel } from '../models/featured-brand.model';
import { ProductsService } from '@core/services/products.service';
import { combineLatest, map, Observable, shareReplay, switchMap } from 'rxjs';
import { BrandsService } from '@core/services/brands.service';

@Injectable()
export class FeaturedBrandsService extends ApiBaseService<FeaturedBrandInterface> {
  public brands$: Observable<FeaturedBrandModel[]> = combineLatest([
    this._brandsService.brandsIdx$,
    this._productsService.productsIdx$,
  ]).pipe(
    switchMap(([brandsIdx, productsIdx]) =>
      this.dataStatic$.pipe(
        map((featured) => featured.map((fb) => new FeaturedBrandModel(fb, brandsIdx, productsIdx))),
      ),
    ),
    map((brands) => brands.filter((b) => b.visible)),
    shareReplay(),
  );

  constructor(
    private _brandsService: BrandsService,
    private _productsService: ProductsService,
  ) {
    super({
      static: {
        url: `${environment.apiStatic}home_carrusel_marcas`,
      },
    });
  }
}
